import { z } from 'zod'
import { Description } from '../../_kernel/Description'
import { Model } from '../../_kernel/architecture'

export const PropertyDescriptionValidation = z.object({
  amenities: z
    .instanceof(Description, { message: '[PropertyDescription] amenities is required' })
    .optional(),
  businessAmenities: z
    .instanceof(Description, { message: '[PropertyDescription] businessAmenities is required' })
    .optional(),
  attractions: z
    .instanceof(Description, { message: '[PropertyDescription] attractions is required' })
    .optional(),
  location: z
    .instanceof(Description, { message: '[PropertyDescription] location is required' })
    .optional(),
  headline: z
    .instanceof(Description, { message: '[PropertyDescription] headline is required' })
    .optional(),
  dining: z
    .instanceof(Description, { message: '[PropertyDescription] dining is required' })
    .optional(),
  rooms: z
    .instanceof(Description, { message: '[PropertyDescription] rooms is required' })
    .optional(),
})

export class PropertyDescription extends Model {
  static create({
    amenities,
    businessAmenities,
    attractions,
    location,
    headline,
    dining,
    rooms,
  }: {
    amenities?: string
    businessAmenities?: string
    attractions?: string
    location?: string
    headline?: string
    dining?: string
    rooms?: string
  }) {
    const params = {
      amenities: amenities ? Description.create({ value: amenities }) : undefined,
      businessAmenities: businessAmenities
        ? Description.create({ value: businessAmenities })
        : undefined,
      attractions: attractions ? Description.create({ value: attractions }) : undefined,
      location: location ? Description.create({ value: location }) : undefined,
      headline: headline ? Description.create({ value: headline }) : undefined,
      dining: dining ? Description.create({ value: dining }) : undefined,
      rooms: rooms ? Description.create({ value: rooms }) : undefined,
    }
    PropertyDescriptionValidation.parse(params)
    return new PropertyDescription(
      params.amenities,
      params.businessAmenities,
      params.attractions,
      params.location,
      params.headline,
      params.dining,
      params.rooms
    )
  }

  static null() {
    return new PropertyDescription()
  }

  static fromJSON({ json }: { json: ReturnType<PropertyDescription['toJSON']> }) {
    return PropertyDescription.create(json)
  }

  constructor(
    private readonly _amenities?: Description,
    private readonly _businessAmenities?: Description,
    private readonly _attractions?: Description,
    private readonly _location?: Description,
    private readonly _headline?: Description,
    private readonly _dining?: Description,
    private readonly _rooms?: Description
  ) {
    super()
  }

  get amenities() { return this._amenities?.value } // prettier-ignore
  get businessAmenities() { return this._businessAmenities?.value } // prettier-ignore
  get attractions() { return this._attractions?.value } // prettier-ignore
  get location() { return this._location?.value } // prettier-ignore
  get headline() { return this._headline?.value } // prettier-ignore
  get dining() { return this._dining?.value } // prettier-ignore
  get rooms() { return this._rooms?.value } // prettier-ignore

  description() {
    return (
      this.headline ||
      this.location ||
      this.rooms ||
      this.amenities ||
      this.businessAmenities ||
      this.dining ||
      this.attractions ||
      ''
    )
  }

  toJSON() {
    return {
      amenities: this._amenities?.value,
      businessAmenities: this._businessAmenities?.value,
      attractions: this._attractions?.value,
      location: this._location?.value,
      headline: this._headline?.value,
      dining: this._dining?.value,
      rooms: this._rooms?.value,
    }
  }
}
